/**
 * Het merkteken van Arch-designer: zes gelijke segmenten rond een blauw
 * midden, naar het "Hexagonion" van ArchiMate 4 — zes domeinen als
 * gelijken rond het Common Domain. Het past ook op de app zelf: één gedeeld
 * model in het midden, de weergaven eromheen. De segmenten volgen de
 * tekstkleur, het midden het accent.
 */

/** Hoekpunten van een zeshoek met de punt naar boven, rond (14, 14). */
function hexPoints(r: number): Array<[number, number]> {
  return Array.from({ length: 6 }, (_, k) => {
    const a = ((-90 + 60 * k) * Math.PI) / 180;
    return [14 + r * Math.cos(a), 14 + r * Math.sin(a)];
  });
}

const OUTER = hexPoints(11.5);
// Elke zijde ingekort aan beide uiteinden, zodat zes losse segmenten ontstaan.
const SEGMENTS = OUTER.map(([x1, y1], k) => {
  const [x2, y2] = OUTER[(k + 1) % 6] as [number, number];
  const t = 0.16;
  return {
    x1: x1 + (x2 - x1) * t,
    y1: y1 + (y2 - y1) * t,
    x2: x2 - (x2 - x1) * t,
    y2: y2 - (y2 - y1) * t,
  };
});
const CENTRE = hexPoints(4.5)
  .map(([x, y]) => `${x.toFixed(2)},${y.toFixed(2)}`)
  .join(" ");

export function ProductMark({ size = 28 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      aria-hidden="true"
      focusable="false"
      className="shrink-0"
    >
      {SEGMENTS.map((s) => (
        <line
          key={`${s.x1.toFixed(2)}-${s.y1.toFixed(2)}`}
          x1={s.x1}
          y1={s.y1}
          x2={s.x2}
          y2={s.y2}
          stroke="currentColor"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
      ))}
      <polygon points={CENTRE} fill="var(--ld-accent)" />
    </svg>
  );
}
